import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../context/AuthContext';
import { loanFlowService } from '../../services/api';
import { Shield, FileText, Lock } from 'lucide-react';

const YOUNITED_FLOW_LOGO = 'https://customer-assets.emergentagent.com/job_de5fd55a-ccb9-4790-966a-0bfe35cdacca/artifacts/fk9u448b_IMG_0370.jpeg';

const BankConnection = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    updateFlow();
  }, []);

  const updateFlow = async () => {
    try {
      const flow = await loanFlowService.getByClient(user.id);
      if (flow) {
        await loanFlowService.update(flow.id, {
          currentStep: 'bank_connection'
        });
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleConnect = () => {
    navigate('/client/loan-flow/bank-selection');
  };

  const handleSkip = () => {
    navigate('/client/loan-flow/processing');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header Younited */}
      <div className="bg-white border-b border-gray-200 py-4 px-6">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <img src={YOUNITED_FLOW_LOGO} alt="Younited" className="h-10 w-auto object-contain" />
          <div className="flex items-center space-x-4 text-sm text-gray-600">
            <span className="hover:underline cursor-pointer" onClick={() => navigate('/client/help-contact')}>Aide & Contact</span>
            <span className="hover:underline cursor-pointer" onClick={() => navigate('/client/dashboard')}>Vos justificatifs</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-xl mx-auto px-4 pb-8">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_credit-loan-site/artifacts/132nabgh_85AE9E79-6561-4E2F-9669-C3D940A28C7C.png" 
            alt="Relevé bancaire" 
            className="h-16 w-auto object-contain"
          />
        </div>

        {/* Title */}
        <h1 className="text-xl md:text-2xl font-bold text-gray-900 text-center mb-8 leading-tight">
          Ajoutez vos relevés de compte en vous connectant à votre banque. Cette étape est indispensable pour finaliser votre demande
        </h1>

        {/* Benefits */}
        <div className="space-y-4 mb-8">
          <div className="flex items-start space-x-3">
            <span className="text-xl">😊</span>
            <div>
              <p className="font-semibold text-gray-900">Indispensable pour finaliser votre demande :</p>
              <p className="text-gray-600 text-sm">nous assure un document fiable pour votre dossier</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <span className="text-xl">📄</span>
            <div>
              <p className="font-semibold text-gray-900">Récupération automatique :</p>
              <p className="text-gray-600 text-sm">aucun document à scanner ou à télécharger</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <Shield className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" />
            <div>
              <p className="font-semibold text-gray-900">Connexion sécurisée sur le site de votre banque :</p>
              <p className="text-gray-600 text-sm">Younited n'a accès à aucune de vos données de connexion</p>
            </div>
          </div>
        </div>

        {/* Learn More Link */}
        <div className="text-center mb-6">
          <a href="#" className="text-sm font-medium" style={{ color: '#8B5CF6' }}>
            En savoir plus sur la récupération automatique
          </a>
        </div>

        {/* Connect Button */}
        <Button
          onClick={handleConnect}
          className="w-full text-white font-semibold py-4 text-base mb-4"
          style={{ backgroundColor: '#E11D28' }}
          data-testid="connect-bank-btn"
        >
          Me connecter à ma banque
        </Button>

        {/* Legal Text */}
        <p className="text-xs text-gray-500 text-center mb-6">
          En cliquant sur « Me connecter à ma banque », vous autorisez Younited Crédit à procéder à une identification unique auprès de votre établissement bancaire afin de consulter vos opérations bancaires sur une période de 45 à 90 jours, selon les modalités propres à chaque banque.
        </p>
      </div>

      {/* Footer */}
      <div className="bg-gray-100 border-t py-4 mt-8">
        <div className="max-w-4xl mx-auto px-4 flex flex-wrap justify-center gap-4 text-xs text-gray-500">
          <a href="#" className="hover:underline">Mentions légales</a>
          <span className="hidden md:inline">•</span>
          <a href="#" className="hover:underline">Utilisation des données</a>
          <span className="hidden md:inline">•</span>
          <a href="#" className="hover:underline">Gérer mes cookies</a>
          <span className="hidden md:inline">•</span>
          <a href="#" className="hover:underline">Accessibilité</a>
        </div>
      </div>
    </div>
  );
};

export default BankConnection;
